import React from "react";
import Styles from "./ViewInjectDrawal.module.css";
import { Modal } from "@mui/material";
import { Close } from "@mui/icons-material";
import { useSelector } from "react-redux";
import { usePdfPreview } from "../../../../hooks/usePdfPreview";

const ViewInjectDrawal = ({ data, open, handleClose, activeListingId }) => {
  const user = useSelector(
    (state) => state.persistedReducer.user?.activeRole,
  )?.toLowerCase();

  const listing = data.filter((item) => item.id === activeListingId);

  const formatDate = (dateStr) => {
    if (!dateStr) return "—";
    const date = new Date(dateStr);
    if (isNaN(date)) return "—";
    const day = String(date.getDate()).padStart(2, "0");
    const month = date.toLocaleString("en-US", { month: "short" });
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  };

  const formatTime = (timeStr) => {
    if (timeStr === "23:59") return "24:00";
    return timeStr || "—";
  };

  const { handlePreviewGeneralTerms, PdfPreviewModal } = usePdfPreview();
  const isDocumentAvailable =
    listing[0]?.termsDocumentId || listing[0]?.tenderDoc;

  return (
    <>
      <PdfPreviewModal />
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="child-modal-title"
        aria-describedby="child-modal-description"
      >
        <div className={`popupModal ${Styles.createEditModalCont}`}>
          <div
            className={`display_flex_row modalHeading ${Styles.modalHeading}`}
          >
            <div className="headingText">Requisition List</div>
            <Close
              style={{ fontSize: "24px", color: "#777777", cursor: "pointer" }}
              onClick={handleClose}
            />
          </div>
          <div className={Styles.indentsMainContainer}>
            <div className={Styles.indentsMainTableSection}>
              <div className={Styles.secondaryHeading}>
                <div className={Styles.headerRow}>
                  <div>
                    <span className={Styles.headerLabel}>
                      {listing[0]?.tenderNumber ? "Tender ID" : "Listing ID"}
                    </span>
                    <span className={Styles.headerValue}>
                      {listing[0]?.name || listing[0]?.tenderNumber || "—"}
                    </span>
                  </div>
                  {listing?.[0]?.auctionNumber && (
                    <div>
                      <span className={Styles.headerLabel}>Auction ID</span>
                      <span className={Styles.headerValue}>
                        {listing[0]?.auctionNumber || "—"}
                      </span>
                    </div>
                  )}
                  <div>
                    <span className={Styles.headerLabel}>
                      Initial Margin (%)
                    </span>
                    <span className={Styles.headerValue}>
                      {listing[0]?.initialMargin ||
                        listing[0]?.initialMarginPercent ||
                        "—"}
                    </span>
                  </div>
                  <div>
                    <span className={Styles.headerLabel}>EMD (%)</span>
                    <span className={Styles.headerValue}>
                      {listing[0]?.emd || listing[0]?.emdPerMw || "—"}
                    </span>
                  </div>
                  <div>
                    <span className={Styles.headerLabel}>General T&C</span>
                    <span
                      onClick={() => {
                        if (!isDocumentAvailable) return;
                        handlePreviewGeneralTerms(isDocumentAvailable);
                      }}
                      className={Styles.headerLink}
                      style={{
                        color: isDocumentAvailable ? "var(--primary-color-text)" : "#9b9595",
                        cursor: isDocumentAvailable ? "pointer" : "not-allowed",
                        opacity: isDocumentAvailable ? 1 : 0.5,
                        pointerEvents: isDocumentAvailable ? "auto" : "none",
                      }}
                    >
                      View
                    </span>
                  </div>
                  {!listing[0]?.tenderNumber && (
                    <div>
                      <span className={Styles.headerLabel}>Profile</span>
                      <span onClick={() => {}} className={Styles.headerLink}>
                        View
                      </span>
                    </div>
                  )}
                </div>
                <div className={Styles.commentRow}>
                  <span className={Styles.headerLabel}>Comments</span>
                  <span className={Styles.headerValue}>
                    {listing[0]?.comment}
                  </span>
                </div>
              </div>
              <div className={Styles.tableIndentsContent}>
                <div className={Styles.tableIndentsHeaderSection}>
                  <div className={Styles.indentsHeading}>Start & End Date</div>
                  <div className={Styles.indentsHeading}>Start & End Time</div>
                  <div className={Styles.indentsHeading}>Quantity (MW)</div>
                  <div className={Styles.indentsHeading}>
                    {listing[0]?.tenderNumber
                      ? "Minimum Quantity(MW)"
                      : "Energy Rate (₹/kWh)"}
                  </div>
                </div>
                <div className={Styles.searchTableSection}>
                  {listing[0]?.slots?.map((item) => (
                    <div key={item.id} className={Styles.indentsListTable}>
                      <div className={Styles.indentsListHeading}>
                        {formatDate(item.dateStartAt)} to{" "}
                        {formatDate(item.dateEndAt)}
                      </div>
                      <div className={Styles.indentsListHeading}>
                        {formatTime(item.slotStartAt)}–
                        {formatTime(item.slotEndAt)}
                      </div>
                      {user === "super_admin" ? (
                        <>
                          <div className={Styles.indentsListHeading}>
                            {item.requiredQty ||
                              item?.sellEnergy ||
                              item?.purchaseEnergy ||
                              "—"}
                          </div>
                          <div className={Styles.indentsListHeading}>
                            {item.minimumQty ||
                              item?.sellingCost ||
                              item?.landingCost ||
                              "—"}
                          </div>
                        </>
                      ) : user === "consumer" ? (
                        <>
                          <div className={Styles.indentsListHeading}>
                            {item.purchaseEnergy || "—"}
                          </div>
                          <div className={Styles.indentsListHeading}>
                            {item.landingCost || "—"}
                          </div>
                        </>
                      ) : (
                        <>
                          <div className={Styles.indentsListHeading}>
                            {item.sellEnergy || "—"}
                          </div>
                          <div className={Styles.indentsListHeading}>
                            {item.sellingCost || "—"}
                          </div>
                        </>
                      )}
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default ViewInjectDrawal;
